// Core icon bundle - frequently used icons bundled together
// This reduces network requests from 100+ individual icon chunks to 1 bundle
import React from 'react';
import { SvgIconProps } from '@mui/material/SvgIcon';

// Import core icons that are used frequently across the app
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckIcon from '@mui/icons-material/Check';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ClearIcon from '@mui/icons-material/Clear';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import DoneIcon from '@mui/icons-material/Done';
import DownloadIcon from '@mui/icons-material/Download';
import EditIcon from '@mui/icons-material/Edit';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FlightIcon from '@mui/icons-material/Flight';
import HelpIcon from '@mui/icons-material/Help';
import InfoIcon from '@mui/icons-material/Info';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import RefreshIcon from '@mui/icons-material/Refresh';
import SaveIcon from '@mui/icons-material/Save';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import WarningIcon from '@mui/icons-material/Warning';

// Core icon bundle mapping - these are bundled together
export const coreIcons: Record<string, React.ComponentType<SvgIconProps>> = {
  AddIcon,
  ArrowBackIcon,
  ArrowDropDownIcon,
  CheckIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ClearIcon,
  CloseIcon,
  DeleteIcon,
  DoneIcon,
  DownloadIcon,
  EditIcon,
  ExpandLessIcon,
  ExpandMoreIcon,
  FlightIcon,
  HelpIcon,
  InfoIcon,
  MoreHorizIcon,
  MoreVertIcon,
  NextIcon: NavigateNextIcon,
  RefreshIcon,
  SaveIcon,
  SearchIcon,
  SettingsIcon,
  VisibilityIcon,
  VisibilityOffIcon,
  WarningIcon,
};

// Check if an icon is in the core bundle
export const isCoreIcon = (iconName: string): boolean => {
  return iconName in coreIcons;
};

// Get a core icon component
export const getCoreIcon = (iconName: string): React.ComponentType<SvgIconProps> | null => {
  return coreIcons[iconName] || null;
};